<template>
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.6863 10.1288C3.82171 10.6436 1.55483 11.6948 2.93552 13.0103C3.60997 13.6528 4.36113 14.1124 5.30553 14.1124H10.6945C11.6389 14.1124 12.39 13.6528 13.0645 13.0103C14.4452 11.6948 12.1783 10.6436 11.3137 10.1288C9.28627 8.92158 6.71373 8.92158 4.6863 10.1288Z"
      stroke="currentColor"
      stroke-width="1.21"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.7496 4.63995C10.7496 6.15877 9.51834 7.39001 7.99956 7.39001C6.48077 7.39001 5.24956 6.15877 5.24956 4.63995C5.24956 3.12114 6.48077 1.88989 7.99956 1.88989C9.51834 1.88989 10.7496 3.12114 10.7496 4.63995Z"
      stroke="currentColor"
      stroke-width="1.21"
    />
  </svg>
</template>
